"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var types_1 = require("../../../../types");

var procedures_1 = require("../../../../procedures");

var SubModule_1 = require("../../SubModule");

var PolymathError_1 = require("../../../../PolymathError");
/**
 * Namespace that handles all Percentage Restriction related functionality
 */


var PercentageRestrictions =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(PercentageRestrictions, _SubModule_1$SubModul);

  function PercentageRestrictions() {
    var _this;

    _classCallCheck(this, PercentageRestrictions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PercentageRestrictions).apply(this, arguments));
    /**
     * Modify the conditions for exemption from percentage ownership restrictions. There are two (independent) methods of exemption:
     *
     * - Whitelisting: an address can be whitelisted and thus percentage ownership restrictions will not apply to it
     * - Primary issuance: if enabled, issuing tokens to an address will bypass percentage ownership restrictions (for example, if issuing tokens to a particular address would leave that address with a higher percentage than the limit, having this option set to `true` will allow that issuance operation)
     *
     * @param args.whitelistEntries - it can be optional. List of addresses to add/remove from the whitelist
     * @param args.allowPrimaryIssuance - it can be optional. If set to true, issuing tokens to an address is allowed even if it would leave said address over the percentage ownership limit
     */

    _this.modifyExemptions = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                procedure = new procedures_1.ModifyPercentageExemptions(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Retrieve all exemptions that currently apply to percentage restrictions. That includes the whitelist and whether primary issuance (minting) is allowed to bypass percentage ownership restrictions
     *
     * Can be modified with `modifyPercentageExemptions`
     */


    _this.getExemptions = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var contractWrappers, securityToken, symbol, _ref, _ref2, percentageTransferManagerModule, _ref3, _ref4, logs, isPrimaryIssuanceAllowed, whitelist, addresses;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context2.next = 4;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.PercentageTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 4:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 1);
                percentageTransferManagerModule = _ref2[0];

                if (percentageTransferManagerModule) {
                  _context2.next = 9;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the PercentageOwnershipRestrictions Feature'
                });

              case 9:
                _context2.next = 11;
                return Promise.all([percentageTransferManagerModule.getLogsAsync({
                  eventName: contract_wrappers_1.PercentageTransferManagerEvents.ModifyWhitelist
                }), percentageTransferManagerModule.allowPrimaryIssuance()]);

              case 11:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                logs = _ref4[0];
                isPrimaryIssuanceAllowed = _ref4[1];
                whitelist = {};
                logs.forEach(function (_ref5) {
                  var _ref5$args = _ref5.args,
                      _investor = _ref5$args._investor,
                      _valid = _ref5$args._valid,
                      blockNumber = _ref5.blockNumber;
                  var entry = whitelist[_investor];

                  if (!entry || !blockNumber || blockNumber >= entry.blockNumber) {
                    whitelist[_investor] = {
                      whitelisted: _valid,
                      blockNumber: blockNumber || -1
                    };
                  }
                });
                addresses = lodash_1.keys(whitelist);
                return _context2.abrupt("return", {
                  exemptedAddresses: addresses.filter(function (address) {
                    return whitelist[address].whitelisted;
                  }),
                  isPrimaryIssuanceAllowed: isPrimaryIssuanceAllowed
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Modify the maximum percentage of the total supply that a single tokenholder can own at a given time
     *
     * @param args.maxHolderPercentage - limit to the percentage a tokenholder can own (i.e. `new BigNumber(55.75)` for 55.75%)
     */


    _this.modifyMaxHolderPercentage = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                procedure = new procedures_1.ModifyMaxHolderPercentage(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Retrieve the maximum percentage of the total supply that a single tokenholder can own
     * Can be modified with `modifyMaxHolderPercentage`
     */


    _this.getMaxHolderPercentage = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var contractWrappers, securityToken, symbol, percentageTransferManagerModule;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context4.next = 4;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.PercentageTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 4:
                percentageTransferManagerModule = _context4.sent[0];

                if (percentageTransferManagerModule) {
                  _context4.next = 7;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the PercentageOwnershipRestrictions Feature'
                });

              case 7:
                return _context4.abrupt("return", percentageTransferManagerModule.maxHolderPercentage());

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    return _this;
  }

  return PercentageRestrictions;
}(SubModule_1.SubModule);

exports.PercentageRestrictions = PercentageRestrictions;